<template>
  <div v-loading="pageLoading">
    <el-form ref="form" :model="form" :rules="rules" label-width="110px" class="w-200 m-t-20 m-l-20">
      <el-form-item label="显示/消失动画时间（秒）" prop="time">
        <el-input v-model.number="form.time"></el-input>
      </el-form-item>
      <el-form-item label="按钮样式">
        <el-select v-model="form.style" placeholder="请选择">
          <el-option
            v-for="item in styles"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否虚化">
        <el-switch
          v-model="form.isOpacity"
          on-text=""
          off-text="">
        </el-switch>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit" :loading="btnLoading">保存</el-button>
        <el-button @click="goBack">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
  import http from 'assets/js/http'
  import widgetConfig from './widgetConfig'
  export default {
    data() {
      return {
        id: null,
        obj: null,
        form: {
          time: 3,
          style: 10,
          isOpacity: false
        },
        styles: [{
          label: '样式1',
          value: 10
        }, {
          label: '样式2',
          value: 20
        }, {
          label: '样式3',
          value: 30
        }, {
          label: '样式4',
          value: 40
        }],
        rules: {
          time: [
            { type: 'number', message: '时间必须为数字' }
          ]
        }
      }
    },
    methods: {
      onSubmit() {
        this.btnLoading = true
        this.obj.config = this.form
        const postData = _g.s2j(_g.j2s(this.obj))
        this.apiPut(`mobile/components/${this.id}/save`, '', postData).then((res) => {
          this.handleResult(res)
        })
      }
    },
    async created() {
      this.pageLoading = true
      this.id = this.getId()
      const obj = await this.getWidgetConfig(this.id)
      this.pageLoading = false
      this.obj = obj
      if (obj.config) {
        this.form = obj.config
      }
    },
    mixins: [http, widgetConfig]
  }
</script>


// WEBPACK FOOTER //
// goTop.vue?5fd6c47c